<div class="form-row" [formGroup]="formGroup">
    <div class="form-group col-md-3">
        <label for="codiceFiscale">Codice fiscale*</label>
        <input class="form-control" id="codiceFiscale" formControlName="codiceFiscale" type="text">
    </div>
    <div class="form-group col-md-3">
        <label for="cognome">Cognome*</label>
        <input class="form-control" id="cognome" formControlName="cognome" type="text">
    </div>
    <div class="form-group col-md-3">
        <label for="nome">Nome*</label>
        <input class="form-control" id="nome" formControlName="nome" type="text">
    </div>
    <div class="form-group col-md-3">
        <label for="email">Email*</label>
        <input class="form-control" id="email" formControlName="email" type="text">
    </div>
    <div class="form-group col-md-3">
        <label for="emailIstituzionale">Email istituzionale*</label>
        <input class="form-control" id="emailIstituzionale" formControlName="emailIstituzionale" type="text">
    </div>
    <div class="form-group col-md-3">
        <label for="ente">Ente*</label>
        <select class="form-control" formControlName="ente" id="ente">
            <option [ngValue]="null">Seleziona un'opzione...</option>
            <option *ngFor="let ente of datalist.ente" [ngValue]="ente.id">{{ ente.descrizione }}</option>
        </select>
    </div>
    <div class="form-group col-md-3">
        <label for="ruolo">Ruolo*</label>
        <select class="form-control" formControlName="ruolo" id="ruolo">
            <option [ngValue]="null">Seleziona un'opzione...</option>
            <option [ngValue]="1">Amministratore</option>
            <option [ngValue]="2">Operatore</option>
        </select>
    </div>
    <div class="form-group col-md-3" *ngIf="utenteService.isRuoloAmministratore()">
        <label for="status">Stato</label>
        <select class="form-control" formControlName="status" id="status">
            <option [ngValue]="null">Seleziona un'opzione...</option>
            <option [ngValue]="1">In approvazione</option>
            <option [ngValue]="2">Approvato</option>
            <option [ngValue]="3">Rifiutato</option>
        </select>
    </div>
</div>